export const TransferSpaceService = Symbol('TransferSpaceService');
